import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MemberProxyService } from './service/member-proxy.service';
import { FacebookMemberModule } from './module/facebook-member/facebook-member.module';
import { GoogleMemberModule } from './module/google-member/google-member.module';
import { CultureCenterMemberModule } from './module/culture-center-member/culture-center-member.module';
import { SignOutComponent } from './component/sign-out/sign-out.component';


/** 會員模組 */
@NgModule({
  imports: [
    CommonModule,
    CultureCenterMemberModule,
    GoogleMemberModule,
    FacebookMemberModule,
  ],
  declarations: [
    SignOutComponent
  ],
  exports: [
    CultureCenterMemberModule,
    GoogleMemberModule,
    FacebookMemberModule,
    SignOutComponent,
  ]
})
export class MemberProxyModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: MemberProxyModule,
      providers: [
        MemberProxyService,
        ...CultureCenterMemberModule.forRoot().providers,
        ...GoogleMemberModule.forRoot().providers,
        ...FacebookMemberModule.forRoot().providers,
      ]
    };
  }
}
